import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@/app/modules/auth/core/Auth';
import { dismissFirstAccess } from '@/app/pages/home/core/_requests';

const WelcomeModal = () => {
  const { currentUser, setCurrentUser } = useAuth();
  const [show, setShow] = useState(currentUser?.first_access === true);

  const mutation = useMutation({
    mutationFn: () => dismissFirstAccess(),
  });

  const handleDismiss = () => {
    setShow(false);
    mutation.mutate();
  };

  // Mesmo se a chamada falhar: com `first_access` ainda true, a entrada travaria nas boas-vindas escondidas.
  const handleExited = () => {
    if (!currentUser) return;
    setCurrentUser({ ...currentUser, first_access: false });
  };

  return (
    <Modal centered show={show} size="lg" onExited={handleExited} onHide={handleDismiss}>
      <Modal.Body className="text-center p-10">
        <div className="mb-6">
          <img
            alt="Boas vindas"
            className="mw-100"
            src="/media/illustrations/sigma-1/17.png"
            style={{ maxHeight: 200 }}
          />
        </div>
        <button
          className="btn btn-icon btn-sm btn-light-primary position-absolute top-0 end-0 m-4"
          type="button"
          onClick={handleDismiss}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </button>
        <h2 className="fw-bold text-gray-900 mb-4">Boas vindas ao Sistema!</h2>
        <p className="text-gray-600 fs-5 mb-6">
          A partir de agora, você conta com as nossas soluções de ponta a ponta para sua operação ganhar fôlego e
          escala.
        </p>
        <ul className="text-start list-unstyled mb-6 mx-auto" style={{ maxWidth: 400 }}>
          <li className="d-flex align-items-center gap-3 mb-3">
            <i className="ki-duotone ki-check-circle fs-2 text-success">
              <span className="path1" />
              <span className="path2" />
            </i>
            <span className="text-gray-700 fs-6">Mais controle, menos retrabalho</span>
          </li>
          <li className="d-flex align-items-center gap-3 mb-3">
            <i className="ki-duotone ki-check-circle fs-2 text-success">
              <span className="path1" />
              <span className="path2" />
            </i>
            <span className="text-gray-700 fs-6">Processos integrados e automatizados</span>
          </li>
          <li className="d-flex align-items-center gap-3">
            <i className="ki-duotone ki-check-circle fs-2 text-success">
              <span className="path1" />
              <span className="path2" />
            </i>
            <span className="text-gray-700 fs-6">Suporte em cada etapa, do cadastro à venda</span>
          </li>
        </ul>
        <p className="text-gray-500 fs-6 mb-8">Conheça o produto e confira tudo isso em ação.</p>
        <button className="btn btn-primary px-8" disabled={mutation.isPending} type="button" onClick={handleDismiss}>
          {mutation.isPending ? 'Carregando...' : 'Continuar'}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default WelcomeModal;
